module.exports = __webpack_public_path__ + "media/src/images/logo-dark-bg@2x-66c36ee0f1b6676cde17e94b01af060e.png";